
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"808","viewBox":"0 0 808 262","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-98 -105)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0c80.904 203.562 224.598 42.675 448 204 130.5 94.238 254.255 42.791 336 67.27 56.677 16.973 97.677 49.55 123 97.73","stroke":"#006CB5","stroke-linecap":"round","stroke-linejoin":"round","stroke-dasharray":"0,5"}}),_c('circle',{attrs:{"fill":"#006CB5","cx":"431","cy":"192","r":"6"}})])])
          )
        }
      }
    